import React, { memo } from 'react';
import IsoFlag from '../IsoFlag';
import { getLeagueCountryCode, getLeagueFlag } from '../../utils/leagueUtils';

const FLAG_SIZE = 16;

const LeagueFlag = memo(({ leagueId, size = FLAG_SIZE, className = '' }) => {
  const countryCode = getLeagueCountryCode(leagueId);
  const emoji = getLeagueFlag(leagueId);

  if (countryCode) {
    return <IsoFlag countryCode={countryCode} size={size} className={className} />;
  }

  return (
    <span
      className={`inline-flex items-center justify-center flex-shrink-0 leading-none ${className}`}
      style={{ fontSize: size, width: size, height: size }}
      aria-hidden="true"
    >
      {emoji}
    </span>
  );
});

LeagueFlag.displayName = 'LeagueFlag';

export default LeagueFlag;
